import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useState } from 'react';
import { Document, Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './service/styles';
import { useStore } from '../../../../app/stores/store';

type LTOLabelProps = {
  localElement: any[];
  metadata: any[];
};

const chunkArray = <T,>(array: T[], size: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const LTOLabelGeneration: React.FC<LTOLabelProps> = ({ localElement, metadata }) => {
  const { metaDataStore } = useStore();                         
  const filmTitle = metaDataStore.ltoLabelTitle.replace(" ", "_") || '';
  const [lto, setLto] = useState<string>('');
  const [originalLTOs, setOriginalLTOs] = useState<string[]>([]);
  const [cloneLTOs, setCloneLTOs] = useState<string[]>([]);
  const [rawCookedFormats, setRawCookedFormats] = useState<string[]>([]);

  useEffect(() => {
    const combined = [...localElement, ...metadata];

    combined.forEach((element) => {
      const valueList = element.elementValue?.split('|').filter(Boolean) || [];

      if (element.elementName === 'LTO Generation') {
        const value = element.elementValue.replace("-", "");
        setLto(value);
      } else if (element.elementName === 'ORIGINAL LTO') {
        setOriginalLTOs(valueList);
      } else if (element.elementName === 'CLONE LTO') {
        setCloneLTOs(valueList);
      } else if (element.elementName === 'RAWCOOKED TYPE') {
        setRawCookedFormats(valueList);
      }
    });
  }, [localElement, metadata]);

  const labelData = useMemo(() => {
    return [
      ...originalLTOs.map((code) => ({ ltoCode: `${lto} - ${code}`, filmTitle })),
      ...cloneLTOs.map((code) => ({ ltoCode: `${lto} - ${code}`, filmTitle })),
    ];
  }, [originalLTOs, cloneLTOs, lto, filmTitle]);

  const pages = chunkArray(labelData, 8);

  return (
    <Document>
      {pages.map((labelsChunk, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.pageLTO}>
          <View style={styles.containerLTO}>
            {labelsChunk.map((label, index) => (
              <View key={index} style={styles.labelBoxLTO}>
                <View style={styles.logoRowLTO}>
                  <Image src="/assets/labelHeading.png" style={styles.logoLTO} />
                </View>
                <Text style={styles.ltoCode}>{label.ltoCode}</Text>
                <Text style={styles.filmTitle}>{label.filmTitle}</Text>
                <View style={styles.formatList}>
                  {rawCookedFormats.map((format, i) => (
                    <Text key={i}>{format}</Text>
                  ))}
                  <Text>DCP</Text>
                  <Text>ProRes</Text>
                  <Text>MP4</Text>
                </View>
              </View>
            ))}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default observer(LTOLabelGeneration);
